export const QA_NAME_LISTING_PROFILE_PAGE = 'rentalPortalListing'

export const QA_NAME_LISTING_PROFILE_PREVIEW_OPEN_FULL_PAGE =
  'listingPreviewOpenFullPage'

export const QA_NAME_LISTING_PROFILE_PREVIEW_OPEN_PROFILE =
  'listingPreviewOpenProfile'

export const QA_NAME_LISTING_PROFILE_PREVIEW_RETRY = 'listingPreviewRetry'

export const LISTING_PROFILE_EDIT_BLOCK = {
  description: 'description',
  keyFacts: 'keyFacts',
}

export const QA_NAME_LISTING_PROFILE_WIDGET_ADDRESS = 'listingAddress'

export const QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION = 'listingNeedsAttention'

export const QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION_ACTION =
  'listingNeedsAttentionAction'

export const QA_NAME_LISTING_PROFILE_WIDGET_CREATED = 'listingCreated'

export const QA_NAME_LISTING_PROFILE_WIDGET_PERFORMANCE = 'listingPerformance'

export const QA_NAME_LISTING_PROFILE_WIDGET_PUBLISHING = 'listingPublishing'

export const LISTING_PUBLISHINGS_TAB_SEGMENT = 'publishings'
